import { IVeriLiteEvent, VeriLiteInformationEvent, IResources, VeriLiteEventAction, IUser, IMultiSelectOption } from '../../../../../Types';
import * as React from 'react';
import { Input, FormFeedback, Row, Col, InputGroup, InputGroupAddon, InputGroupText, CustomInput } from 'reactstrap';
import { Auth } from '../../../../../Services/AuthenticationService';
import { defaultPostOptions, UserRequestHeaders } from '../../../../../Services/Util';
import { CustomSpinner } from '../../../../../Components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { EventHandlerProvider } from '../../../../../Services/EventHandlerService';
import { IUserData } from './Exports';
import { MultiSelect } from '../../../../../Components';

export function EditUserEvent(updateCallback: () => void, user: IUserData, resources: IResources, locations:any, isSuperUser: boolean, isOwnEdit:boolean) {
    var editUserEventContentRef = React.createRef<EditUserEventContent>();

    return new VeriLiteInformationEvent(
        <EditUserEventContent ref={editUserEventContentRef} updateCallback={updateCallback} user={user} resources={resources} locations={locations} isSuperUser={isSuperUser} isOwnEdit={isOwnEdit}/>,
        resources.EditUser,
        [
            new VeriLiteEventAction(
                 resources.Save,
                 "primary",
                 async () => {
                    editUserEventContentRef?.current?.editUser();
                },
                 true
            ), 
            new VeriLiteEventAction(

                 resources.Cancel,
                 "secondary",
                 (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                    closeModalCallback();
                }
            )
        ]
    );
}

enum InputValidationState {
    unset,
    invalid,
    valid
}

enum EditUserEventContentState {
    Initial,
    Pending,
    Success,
    Error
}

interface IInputValidation {
    Error: string;
    State: InputValidationState;
}

const userRoles = (resources: IResources, isSuperUser: boolean, isOwnEdit: boolean):IMultiSelectOption[] => [{
    value: "User",
    label: resources.User,
    isDisabled: true,
    isFixed:true
}, {
    value: "Administrator",
    label: resources.Administrator,
    isDisabled: false,
    isFixed: false
}, {
    value: "SuperUser",
    label: resources.SuperUser,
    isDisabled: !isSuperUser || isOwnEdit,
    isFixed: !isSuperUser  || isOwnEdit
}];

interface ISelectOption {
    value: string;
    label: string;
    isFixed: boolean;
    isDisabled: boolean;
}

interface IEditUserEventContentState {
    UserData: IUser;
    UserDataValidation: IUserValidation;
    status: EditUserEventContentState;
    ApplicationValidation: IInputValidation;
    UserRoleSelectOptions: ISelectOption[];
    SelectOptions: IMultiSelectOption[];
    roles: string;
    isNumberInputValid: boolean;
}

interface IEditUserEventContentProps {
    updateCallback: () => void;
    locations: any;
    user: IUserData;
    resources: IResources;
    isSuperUser: boolean;
    isOwnEdit: boolean;
}

interface IRequestError {
    title: string;
    detail: string;
}

interface IUserValidation {
    [key: string]: IInputValidation;
    DisplayName: IInputValidation;
}

const customStyles = {
    container: (provided:any) => ({
        ...provided,
        flex: '1 1'
    }),
    control: (provided:any) => ({
        ...provided,
        borderRadius: "0px 4px 4px 0px"    
    })
}

const propertyNames = {InactivityTimeout: "InactivityTimeout"};

class EditUserEventContent extends React.Component<IEditUserEventContentProps, IEditUserEventContentState>{
    constructor(props: IEditUserEventContentProps) {
        super(props);
        console.log(props.user)
        var roles:IMultiSelectOption[] = [];
        var options = userRoles(props.resources, props.isSuperUser, props.isOwnEdit);
        this.props.user.userRole.split(', ').forEach((role) => {
            var option = options.find(o => o.value == role)
            if (option) {
                roles.push(option);
            }
        })
        if (roles.some(r => r.value == "SuperUser")) {
            var adminIndex = roles.findIndex((v) => v.value == "Administrator");
            roles[adminIndex].isDisabled = true;
            roles[adminIndex].isFixed = true;
        }
        else if (!props.isSuperUser){
            options = [options[options.findIndex((o) => o.value == "User")], options[options.findIndex((o) => o.value == "Administrator")]];
        }
        this.state = {
            UserData: { 
                DisplayName: props.user.displayName, 
                DefaultLocation: props.user.defaultLocation, 
                Id: props.user.id, Email: props.user.email, 
                TwoFactorAuthentication: props.user.twoFactorAuthentication, 
                InactivityTimeout : props.user.inactivityTimeout 
            } as IUser,
            UserDataValidation: {   
                                    DisplayName: {Error: "", State : InputValidationState.unset}, 
                                    InactivityTimeout: {Error: "", State : InputValidationState.unset}
                                },
            status: EditUserEventContentState.Initial,
            ApplicationValidation: { Error: "", State: InputValidationState.unset },
            UserRoleSelectOptions: roles,
            SelectOptions: options,
            roles: props.user.userRole,
            isNumberInputValid: true
        };
    }

    error: IRequestError = {} as IRequestError;
    private isValid = (input: InputValidationState): boolean => {
        return input === InputValidationState.valid;
    };

    private isInvalid = (input: InputValidationState): boolean => {
        return input === InputValidationState.invalid;
    };

    private isFormValid = ():boolean => {
        var validationResult: boolean = true;
        for(var key in this.state.UserDataValidation) {
            validationResult = validationResult && this.state.UserDataValidation[key].State != InputValidationState.invalid
        }
        return validationResult;
    }

    private clearValidation = () => {
        console.error("undefined method clearValidation");
    };


    private validateInput = (inputName: string ): IInputValidation => {
        var error = "";
        var state = InputValidationState.unset;
        if (typeof this.state.UserData[inputName] !== "string" || this.state.UserData[inputName] === undefined || this.state.UserData[inputName] === null || this.state.UserData[inputName] === "") {
            error = this.props.resources.Registration_Validation_RequiredField;
            state = InputValidationState.invalid;
        } else if(inputName === propertyNames.InactivityTimeout) {
            var numberProp = this.state.UserData[inputName] as number;
            if (isNaN(numberProp)) {
                error = "You cannot use non-number characters";
                state = InputValidationState.invalid;
            }
            if((numberProp < 5 || numberProp > 120)) {
                error = "Timeout must be between 5 and 120 minutes";
                state = InputValidationState.invalid;
            }
        }
        else {
            state = InputValidationState.valid;
            if (inputName == "DisplayName") {
                if (!/^\S+.{1,}\S$/.test(this.state.UserData[inputName])) {
                    error = this.props.resources.InvalidDisplayName;
                    state = InputValidationState.invalid;
                }
                if (this.state.UserData[inputName].length > 30) {
                    error = this.props.resources.DisplayNameTooLong;
                    state = InputValidationState.invalid;
                }
            }
        }
        return { State: state, Error: error };
    };

    private updateUserData = (event: React.ChangeEvent<HTMLInputElement>, propName: string) => {
        this.setState({
            UserData: { ...this.state.UserData, [propName]: event.target.value }
        }, () => {
            var validationData = this.validateInput(propName);
            this.setState({
                UserDataValidation: { ...this.state.UserDataValidation, [propName]: validationData }
            }, () => {                    
                    this.updateSaveButtonStatus();
            });
        });
    };

    private updateValidation = (validationResponse: any) => {
        this.clearValidation();
        this.setState({ ApplicationValidation: { Error: validationResponse, State: InputValidationState.invalid } });
    };

    editUser = async () => {

        var user: IUser = this.state.UserData;

        this.updateModal(EditUserEventContentState.Pending);

        var options: RequestInit = {};

        options = Object.assign({ ...defaultPostOptions }, options);

        const json = JSON.stringify({ user: user, roles: this.state.roles });
        options = { ...options, body: json };

        var userRequestHeaders = new UserRequestHeaders(Auth.getUser());
        var headers = new Headers(options.headers);

        await Auth.getAccessToken().then((token) => {
            headers.append("Authorization", `Bearer ${token}`);
            options.headers = headers;
        }).catch((error) => {
            console.error(`Error adding auth header: ${error}`);
        });

        userRequestHeaders.AppendHeaders(options);


        fetch(`/users/UpdateUser`, options).then((response) => {
            if (!response.ok) {
                switch (response.status) {
                    case 400:
                        this.updateModal(EditUserEventContentState.Initial);
                        response.json().then((validationResponse) => {
                            this.updateValidation(validationResponse);
                        });
                        break;
                    case 402:
                        response.json().then((errorResponse) => {
                            this.error.title = errorResponse.title;
                            this.error.detail = errorResponse.detail;
                            this.updateModal(EditUserEventContentState.Error);
                        });
                        break;
                    case 500:
                        response.json().then((errorResponse) => {
                            this.error.title = errorResponse.title;
                            this.error.detail = errorResponse.detail;
                            this.updateModal(EditUserEventContentState.Error);
                        }).catch(() => {
                            this.error.title = this.props.resources.Error;
                            this.error.detail = this.props.resources.ServerErrorMessage;
                            this.updateModal(EditUserEventContentState.Error);
                        });
                        break;
                    default:
                        response.json().then((errorResponse) => {
                            this.error.title = errorResponse.title;
                            this.error.detail = errorResponse.detail;
                            this.updateModal(EditUserEventContentState.Error);
                        }).catch(() => {
                            this.error.title = this.props.resources.Error;
                            this.error.detail = this.props.resources.UnknownErrorMessage;
                            this.updateModal(EditUserEventContentState.Error);
                        });
                        break;
                }
            }
            else {
                this.updateModal(EditUserEventContentState.Success);
            }
        }).catch((err) => {

            this.error.title = this.props.resources.Error;
            this.error.detail = this.props.resources.UnknownErrorMessage;
            this.updateModal(EditUserEventContentState.Error);

            console.error("Error updating user:");
            console.error(err);
        });
    };

    private updateModal = (newState: EditUserEventContentState) => {
        this.setState({ status: newState });
        switch (newState) {
            case EditUserEventContentState.Success:
                this.props.updateCallback();
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.resources.Success;
                event.actions = [
                    new VeriLiteEventAction(this.props.resources.Finish, "primary", (_currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {closeModalCallback();} )
                ];

                eventHandler.UpdateEvent();
                break;

            case EditUserEventContentState.Error:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.error.title || this.props.resources.Error;
                event.actions = [
                    new VeriLiteEventAction(this.props.resources.Close, "secondary", (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;

            case EditUserEventContentState.Pending:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.resources.LoadingDotDotDot;
                event.actions = [];

                eventHandler.UpdateEvent();
                break;

            case EditUserEventContentState.Initial:
                var eventHandler = EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();

                event.title = this.props.resources.EditUserTitle;
                event.actions = [
                    
                        new VeriLiteEventAction(this.props.resources.Save,"primary",
                        async (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            this.editUser();
                        })
                    , new VeriLiteEventAction(                  

                         this.props.resources.Cancel,
                         "secondary",
                         (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                            closeModalCallback();
                        }
                    )
                ];

                eventHandler.UpdateEvent();
                break;
        }
    };

    unsetValidation = (inputName: string) => {
        if (this.state.UserDataValidation[inputName].State == InputValidationState.valid) {
            var validationState = this.state.UserDataValidation;
            validationState[inputName].State = InputValidationState.unset;
            this.setState({ UserDataValidation: validationState });
        }
    }

    selectOnChange = (value: IMultiSelectOption[]) =>  {        
        var userRoles = "";
        for (var i = 0; i < value.length; i++) {
            userRoles += value[i].value;
            if (i + 1 < value.length) {
                userRoles += ", ";
            }
        }

        this.setState({ UserRoleSelectOptions: value, roles: userRoles }, () => {
            this.updateSaveButtonStatus();
        });

    }

    valueChange = (value: IMultiSelectOption[]) => {
        if (value.some(r => r.value == "SuperUser")) {
            var containAdmin = value.filter((v) => v.value == "Administrator");
            if (containAdmin.length == 0) {
                if (value.length === 2) {
                    value.splice(1, 0, { value: "Administrator", label: this.props.resources.Administrator, isDisabled: true, isFixed: true });
                } else {
                    value.push({ value: "Administrator", label: this.props.resources.Administrator, isDisabled: true, isFixed: true });
                }
             }
            else{
                var adminIndex = value.findIndex((v) => v.value == "Administrator");
                value[adminIndex].isDisabled = true;
                value[adminIndex].isFixed = true;
            }
        }
        else {
            var containAdmin = value.filter((v) => v.value == "Administrator");
            if (containAdmin.length > 0){
                var adminIndex = value.findIndex((v) => v.value == "Administrator");
                value[adminIndex].isDisabled = false;
                value[adminIndex].isFixed = false;
            }
        }
        return value;
    }

    updateSaveButtonStatus = () => {
        var eventHandler = EventHandlerProvider.GetInstance();
        var event = eventHandler.GetEvent();
        //Assuming the save button is action 0
        if (event.actions[0].isDisabled && this.isFormValid()) {
            event.actions[0].isDisabled = false;
            eventHandler.UpdateEvent();
        }
        else if (!event.actions[0].isDisabled && !this.isFormValid()) {
            event.actions[0].isDisabled = true;
            eventHandler.UpdateEvent();
        }

        //Save button will be disabled, if no change has been made
        if (this.props.user.displayName == this.state.UserData.DisplayName 
            && this.props.user.defaultLocation == this.state.UserData.DefaultLocation 
            && this.props.user.twoFactorAuthentication == this.state.UserData.TwoFactorAuthentication 
            && this.props.user.inactivityTimeout == this.state.UserData.InactivityTimeout
            && this.props.user.userRole == this.state.roles) {
            event.actions[0].isDisabled = true;
            eventHandler.UpdateEvent();
        }
    }

    stateBasedRender = (currentState: EditUserEventContentState): JSX.Element => {
        switch (currentState) {
            case EditUserEventContentState.Initial:
                return (<div>
                    <InputGroup className="my-3" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>{this.props.resources.DisplayName}</InputGroupText>
                        </InputGroupAddon>
                        <Input valid={this.isValid(this.state.UserDataValidation.DisplayName.State)} invalid={this.isInvalid(this.state.UserDataValidation.DisplayName.State)} onChange={(e) => this.updateUserData(e, "DisplayName")} value={this.state.UserData.DisplayName} onBlur={() => { this.unsetValidation("DisplayName") }} />
                        {
                            <FormFeedback style={{ textAlign: "right" }}>{this.isInvalid(this.state.UserDataValidation.DisplayName.State) ? this.state.UserDataValidation.DisplayName.Error : ""}</FormFeedback>
                        }
                    </InputGroup>
                    
                    <InputGroup className="my-3" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>{this.props.resources.DefaultLocation}</InputGroupText>
                        </InputGroupAddon>
                        <Input type={"select"}
                            onChange={(e) => this.updateUserData(e, "DefaultLocation")} value={this.state.UserData.DefaultLocation}>                            
                            {
                                this.props.locations.map((location: any) =>
                                    <option key={location.Name} value={location.Name}>
                                        {location.Name}
                                    </option>
                                )
                            }
                        </Input>
                    </InputGroup>

                    <InputGroup className="my-3" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>{this.props.resources.TwoFactorAuthentication}</InputGroupText>
                        </InputGroupAddon>
                        <Input type={"select"}
                            onChange={(e) => this.updateUserData(e, "TwoFactorAuthentication")} value={`${this.state.UserData.TwoFactorAuthentication}`}>                            
                            <option key={this.props.resources.Disabled} value={"false"}>
                                {this.props.resources.Disabled}
                                </option>
                            <option key={this.props.resources.Enabled} value={"true"}>
                                {this.props.resources.Enabled}
                                </option>                            
                        </Input>
                    </InputGroup>
                    <InputGroup className="my-3" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>Inactive timeout (Minutes)</InputGroupText>
                        </InputGroupAddon>
                        <Input
                        type="number"
                        value={this.state.UserData.InactivityTimeout}
                        onChange={(e) => this.updateUserData(e, propertyNames.InactivityTimeout)}
                        invalid={this.isInvalid(this.state.UserDataValidation.InactivityTimeout.State)}
                        valid={this.isValid(this.state.UserDataValidation.InactivityTimeout.State)}/>
                    <FormFeedback>{ this.isInvalid(this.state.UserDataValidation.InactivityTimeout.State)  ? this.state.UserDataValidation.InactivityTimeout.Error : ""}</FormFeedback>
                    </InputGroup>

                    <InputGroup className="my-3" >
                        <InputGroupAddon addonType="prepend" >
                            <InputGroupText>{this.props.resources.Registration_Role}</InputGroupText>
                        </InputGroupAddon>

                        <MultiSelect
                            styles={customStyles}
                            options={this.state.SelectOptions}
                            onChange={this.selectOnChange}
                            initialValue={this.state.UserRoleSelectOptions}
                            valueChange={this.valueChange}
                        />
                    </InputGroup>

                    {this.isInvalid(this.state.ApplicationValidation.State) && <FormFeedback style={{ display: "block" }}>{this.state.ApplicationValidation.Error}</FormFeedback>}
                </div>);
            case EditUserEventContentState.Pending:
                return (<CustomSpinner />);
            case EditUserEventContentState.Success:
                return (<div>
                    <Row className="text-success mb-2">
                        <Col />
                        <Col xs="auto" >
                            <FontAwesomeIcon size="6x" icon={faCheckCircle} />
                        </Col>
                        <Col />
                    </Row>
                    <Row>
                        <Col />
                        <Col xs="auto" >
                            {this.props.resources.EditUserSuccessMessage}
                        </Col>
                        <Col />
                    </Row>
                </div>);

            case EditUserEventContentState.Error:
                return (<div>
                    <Row className="text-danger mb-2">
                        <Col />
                        <Col xs="auto" >
                            <FontAwesomeIcon size="6x" icon={faTimesCircle} />
                        </Col>
                        <Col />
                    </Row>
                    <Row>
                        <Col />
                        <Col xs="auto" >
                            {this.error.detail || this.props.resources.AnErrorHasOccurred}
                        </Col>
                        <Col />
                    </Row>
                </div>);
        }
    };

    render() {
        return this.stateBasedRender(this.state.status);
    }
}